export default __webpack_public_path__ + "static/media/model-2.cc28b22c.jpg";